import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PromoMessage from '../promo-message';
import DatePicker from '../date-picker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import _ from 'underscore';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    /* eslint-disable complexity */
    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in != this.props.logged_in) {
            if (this.props.slant) {
                this.props.requireHoroscope(this.props.date, this.props.sign, `${this.props.slant}_daily`);
            } else {
                this.props.requireHoroscope(this.props.date, this.props.sign, 'horoscopes_daily');
            }

            if (nextProps.logged_in == false && this.props.base_url.match(/vip/)) { //user logs out on VIP page
                document.location.href = this.props.base_url.replace(/\/vip/, '');
            } else if (
                nextProps.logged_in == true
                &&
                nextProps.user.subscriptions
                &&
                nextProps.user.subscriptions.vip
                &&
                !this.props.base_url.match(/vip/)
            ) { //user logs in on non-VIP page
                if (
                    !nextProps.product
                    ||
                    !nextProps.product.type
                    ||
                    !_.contains(['Reading', 'Report'], nextProps.product.type)
                ) {
                    document.location.href = `/vip${this.props.base_url}`;
                }
            }

            return true;
        } else if (nextProps.horoscope != this.props.horoscope) {
            if (nextProps.horoscope && nextProps.horoscope.loaded && !nextProps.horoscope.scope_txt) {
                document.location.href = this.props.base_url;
            }

            return true;
        }


        return false;
    }
    /* eslint-enable complexity */

    /* eslint-disable max-len */
    render({ horoscope, slant, date, base_url, actual_sign }) {
        if (horoscope && horoscope.loaded && horoscope.scope_txt) {
            const placement = base_url.match(/vip/) ? 'in-product' : 'text';
            let tags = slant ? slant : 'general';

            if (base_url.match(/vip/)) {
                tags = 'vip,text,daily';
            }

            return (
                <daily-horoscope slant={slant} date={date} base_url={base_url}>
                    <row className={`is-aligned-center ${actual_sign == 'general' ? 'has-margin-10-top has-margin-25-top-mobile' : ''}`}>
                        <column className='is-1'>
                            <DatePicker
                                url={`${base_url}/${horoscope.sign}/:date`}
                                mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                                maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                                date={dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                                autosubmit='true'
                            />
                        </column>
                        <column className='is-11 has-padding-20-left-mobile'>
                            {this.renderLinks()}
                        </column>
                    </row>
                    {this.renderSubLinks()}
                    {this.renderHeading()}
                    {this.renderAuthor()}
                    {this.renderHoroscope()}
                    <p>
                        <PromoMessage placement={placement} tags={tags} />
                    </p>
                </daily-horoscope>
            );
        }

        return (<daily-horoscope {...this.props} />);
    }
    /* eslint-enable max-len */

    renderHeading = () => {
        if (this.props.horoscope && this.props.horoscope.h2_text) {
            if (this.props.actual_sign != 'general') {
                return (<h1>{this.props.horoscope.h2_text}</h1>);
            }

            return (<h2 className='is-h1'>{this.props.horoscope.h2_text}</h2>);
        }

        return null;
    }

    /* eslint-disable max-len */
    renderLinks = () => {
        if (this.props.horoscope && this.props.horoscope.date_sel) {
            const links = this.props.horoscope.date_sel.links;

            return (
                <div className='daily-links'>
                    {Object.keys(links).map(link => {
                        return (
                            <a
                                href={`${this.props.base_url}/${this.props.horoscope.sign}/${links[link].query}`}
                                className={links[link].selected ? 'selected' : ''}
                                onClick={() => this.trackClick(links[link].title)}
                            >
                                {links[link].title}
                            </a>
                        );
                    })}
                    {this.props.actual_sign != 'general'
                        ?
                        <a
                            className='has-margin-5-top-mobile'
                            href='/readings-reports/subscription/vip-membership'
                            onClick={() => this.trackClick('VIP Horoscopes')}
                        >
                                VIP Horoscopes
                        </a>
                        : null
                    }
                </div>
            );
        }

        return null;
    }
    /* eslint-enable max-len */

    renderSubLinks = () => {
        if (this.props.actual_sign == 'general') {
            const monthlyDate = dayjs();
            if (monthlyDate.date() > 27) {
                monthlyDate.add(1, 'months');
            }

            const links = [
                {
                    route: '/readings-reports/subscription/vip-membership',
                    title: 'VIP Horoscopes',
                },
                {
                    route: '/astrology/weekly-love-horoscopes',
                    title: 'Weekly Love',
                },
                {
                    route: `/horoscopes/monthly/${monthlyDate.format('MMMM-YYYY')}`,
                    title: 'Monthly',
                },
                {
                    route: `/horoscopes/${dayjs().format('YYYY')}`,
                    title: 'Yearly',
                },
            ];

            return (
                <row className='is-wrap is-aligned-center has-margin-15-top has-margin-15-bottom'>
                    <column className='is-12-mobile has-padding-5-top'>
                        <span className='has-margin-15-right'>More Horoscopes:</span>
                    </column>
                    <column className='is-12-mobile has-padding-5-top'>
                        {links.map((link) => {
                            return (
                                <a
                                    className='has-margin-15-right'
                                    href={link.route}
                                    onClick={() => this.trackClick(link.title)}
                                >
                                    {link.title}
                                </a>
                            );
                        })}
                    </column>
                </row>
            );
        }

        return null;
    }

    renderAuthor = () => {
        if (this.props.horoscope && this.props.horoscope.author_slug && this.props.horoscope.author) {
            return (
                <div className='daily-links has-margin-15-bottom'>
                    <a
                        href={`/bios/${this.props.horoscope.author_slug}`}
                        onClick={() => this.trackClick(`by ${this.props.horoscope.author}`)}
                    >
                        by {this.props.horoscope.author}
                    </a>
                </div>
            );
        }

        return null;
    }

    renderHoroscope = () => {
        return this.props.horoscope.scope_txt.split('\n').map((p, key) => {
            if (key === 0) {
                return (
                    <p>
                        <b>{dayjs(this.props.horoscope.date, 'M.D.YY').format('MMMM D, YYYY')}:</b>&nbsp;
                        {p}
                        {this.renderContinue()}
                    </p>
                );
            }

            return (
                <p>{p}</p>
            );
        });
    }

    renderContinue = () => {
        if (this.props.horoscope && this.props.horoscope.continue) {
            return (
                <a href={this.props.horoscope.continue} onClick={() => this.trackClick('Continue')}>Continue</a>
            );
        }

        return null;
    }

    trackClick = (text) => {
        const category = 'Daily Nav';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        const label = `Text - ${text}`;

        this.props.trackEvent([category, action, label]);
    }
}

const mapStateToProps = (state) => ({
    horoscope: state.horoscope,
    logged_in: state.user && state.user.logged_in,
    user: state.user,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    requireHoroscope: (date, sign, type) => dispatch({
        type: 'horoscope:require',
        payload: {
            date: date,
            sign: sign,
            type: type,
        },
    }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
